import React from "react";
import styles from "./UltimosPagosRegistradosComponent.module.css";
import Button from "@mui/material/Button";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";

import jwt_decode from "jwt-decode";
import { AuthContext } from "./../../auth/authContext";
import { ActualizadorContext } from "./../../actualizadorContext/actualizadorContext";
import { DateTime } from "luxon";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  addPrecioMantenimientoAPI,
  obtenerTicketsParaReimpresionAPI,
} from "../../API/ApiPagosRegistrados";

import style from "./UltimosPagosRegistradosComponent.module.css";
import { reimprimirTicket } from "../../API/ApiImpresoraTickets";

import Skeleton from "@mui/material/Skeleton";
import CambiarFormatoFechaHelper from "../../Helpers/CambiarFormatoFechaHelper";
import { solicitarTicketParaImpresion } from "../../API/APIImpresionTickets";
import { toast } from "react-toastify";
import convertToPesosMexicanos from "../../Helpers/ConvertToPesosMexicanos";
import { useLoading } from "../../contexts/LoadingContext";
import { checkPermisosMenuPorUsuarioPorGuidPantalla, checkPermisosPorUsuarioPorGuidPantalla } from "../../API/ApiPermisos";

const UltimosPagosRegistradosComponent = () => {
  const { isLoading, startLoading, stopLoading } = useLoading();

  const { user, dispatch } = React.useContext(AuthContext);

  const { actualizarVentanaContext, dispatchActualizarVentanaContext } =
    React.useContext(ActualizadorContext);

  const [isDisabled, setIsDisabled] = React.useState(false);
  const [finalData, setFinalData] = React.useState([]);
  const [selectedDate, setSelectedDate] = React.useState(DateTime.now().toISODate());
  const [folioFilter, setFolioFilter] = React.useState("");



  const [permisos, setPermisos] = React.useState([]);

  React.useEffect(() => {
    checkPermisosPorUsuarioPorGuidPantalla(user, "cbccc653-1e1c-4b8c-9ba1-67985c23d598").then((resultado) => {

      debugger;
      if (resultado.data === undefined) {
        return;
      }
      setPermisos(resultado.data);
    });
  }, []);


  React.useEffect(() => {
    var { id } = jwt_decode(user.accessToken);
    const fetchPagos = () => {
      // startLoading();
      obtenerTicketsParaReimpresionAPI(user, selectedDate, selectedDate, id).then((resultado) => {
        // stopLoading();
        if (resultado.status === 200) {
          setFinalData(resultado.data);
        } else {
          setFinalData({
            pagosOrdenes: [],
            pagosPrevision: [],
            arregloUnificado: [],
          });
        }
      });
    };
    fetchPagos();
    const interval = setInterval(fetchPagos, 60000);
    return () => clearInterval(interval);
  }, [actualizarVentanaContext, selectedDate, user]);

  const filteredData = finalData.filter((pago) =>
    folioFilter === ""
      ? true
      : pago.folio?.toString().toLowerCase().includes(folioFilter.toLowerCase())
  );



  // Solo mostrar el componente si el permiso existe y allowed es 1
  const permisoReimpresion = permisos.find(p => p.guidFuncion == "de62cf52-ea68-4fac-9d10-cf06b2155c82");
  if (permisos.length > 0 && (!permisoReimpresion || permisoReimpresion.allowed == 1)) {
    return (
      <div className={`container-fluid ${style.contenedorUltimosPagos}`}>
        <div className="row">
          <div className="col-12">
            <h6>
              Últimos Pagos Registrados <br />{" "}
              <small>
                <CalendarTodayIcon fontSize="small" /> {CambiarFormatoFechaHelper(selectedDate)}
              </small>
            </h6>
            <br />
            <div className="mb-3">
              <label htmlFor="fechaSelect">Selecciona la fecha:</label>
              <input
                type="date"
                id="fechaSelect"
                className="form-control"
                value={selectedDate}
                onChange={e => setSelectedDate(e.target.value)}
                max={DateTime.now().toISODate()}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="folioFilter">Buscar por folio:</label>
              <input
                type="text"
                id="folioFilter"
                className="form-control"
                placeholder="Ingrese el folio"
                value={folioFilter}
                onChange={e => setFolioFilter(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mb-2">
            {isLoading ? (
              <>
                <Skeleton variant="rectangular" width="100%" style={{ marginBottom: "10px" }}>
                  <div style={{ paddingTop: "30%" }} />
                </Skeleton>
                <Skeleton variant="rectangular" width="100%" style={{ marginBottom: "10px" }}>
                  <div style={{ paddingTop: "30%" }} />
                </Skeleton>
                <Skeleton variant="rectangular" width="100%" style={{ marginBottom: "10px" }}>
                  <div style={{ paddingTop: "30%" }} />
                </Skeleton>
                <Skeleton variant="rectangular" width="100%" style={{ marginBottom: "10px" }}>
                  <div style={{ paddingTop: "30%" }} />
                </Skeleton>
                <Skeleton variant="rectangular" width="100%" style={{ marginBottom: "10px" }}>
                  <div style={{ paddingTop: "30%" }} />
                </Skeleton>
              </>
            ) : (
              <>
                {filteredData.map((pago) => {
                  return (
                    <React.Fragment key={pago.idpago}>
                      <div className="card mb-2">
                        <div className={`${styles.cardPago} card-body`}>
                          <div className="d-flex justify-content-between">
                            <h6>{pago.folio}</h6>
                          </div>
                          <div className="d-flex justify-content-between">
                            <h6>Fecha</h6>
                            <h6>{DateTime.fromISO(pago.fechaPago).toFormat("dd/MM/yyyy")}</h6>
                          </div>
                          <hr />
                          <div className="d-flex justify-content-between strong d-none">
                            <h6>Metodo</h6>
                            <h6>
                              {pago.idtipoPago == 1
                                ? "Efectivo"
                                : pago.idtipoPago == 2
                                  ? "Tarjeta"
                                  : "No Identificado"}
                            </h6>
                          </div>
                          <div className="d-flex justify-content-between strong">
                            <h6>Total:</h6>
                            <h6>{convertToPesosMexicanos(pago.abono)}</h6>
                          </div>
                          <div className="d-flex justify-content-center strong">
                            <Button
                              variant="text"
                              onClick={() => {
                                let armandoObjeto = {
                                  encabezado: {
                                    urlImagen: "https://login.funerariavitanova.com/logo.jpg",
                                    telefono: "4616120088",
                                    correo: "cobranza@funerariavitanova.com",
                                    paginaWeb: "www.funerariavitanova.com",
                                  },
                                  detalle: {
                                    nombreTitular: pago.nombreTitular,
                                    fechaPago: pago.fechaPago,
                                    folio: pago.folio,
                                    contrato: pago.contrato,
                                    saldoAnterior: pago.saldoAnterior,
                                    abono: pago.abono,
                                    saldoActual: pago.saldoActual,
                                    uuid: pago.uuid,
                                  },
                                };

                                solicitarTicketParaImpresion(user, armandoObjeto).then(() => {
                                  toast.success("Imprimiendo Ticket...");
                                });
                              }}
                            >
                              <LocalPrintshopIcon fontSize="small" /> Reimpresion
                            </Button>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default UltimosPagosRegistradosComponent;
